import type { AppProps } from "next/app";
import "@/app/globals.css";
import { inter } from "@/lib/fonts";
import MetaPixel from "@/components/analytics/MetaPixel";

/**
 * App do Pages Router. Antes só a home (App Router) carregava o Meta Pixel;
 * agora as páginas de revenda/distribuição/contato também são medidas.
 */
export default function App({ Component, pageProps }: AppProps) {
  return (
    <div className={`${inter.variable} font-sans`}>
      <MetaPixel />
      <Component {...pageProps} />
    </div>
  );
}
